import { Box, Button, Center, Heading, HStack, Spinner, VStack } from "@chakra-ui/react";

import Form from "./Form";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useProduct from "./hooks/useProduct";
import { UpdateProductParams } from "@olagg/db-types";

const EditProduct = () => {
  const params = useParams();
  const id = params.id!
  const navigate = useNavigate();
  const { editProduct, getProduct, product, isLoading } = useProduct();

  const onSubmit = async (data: UpdateProductParams) => {
    editProduct(id, data);
  }

  useEffect(() => {
    getProduct(id);
  }, [id])

  const isLocalProduct = product?.source === 'LocalProduct';

  return (
    <>
      <Center w={'full'} pb={4}>
        <VStack color={'white'}>
          <Heading my={2}>
              Editar Producto
          </Heading>
          {isLocalProduct && (
            <HStack mb={2}>
              <Button variant="outlinedGradient" onClick={() => navigate(`/products/${id}/inventario`)}>
                Ver inventario de códigos
              </Button>
            </HStack>
          )}
          {
            isLoading ? (
              <Box height='300px' display='flex' justifyContent='center' alignItems='center' fontWeight='600' flexDirection='column'>
                <Spinner />
              </Box>
            ) : (
              <Form product={product} onSubmit={onSubmit} />
            )
          }
        </VStack>
      </Center>
    </>
  )
}

export default EditProduct;